export const DEFAULT_INTERVAL = 10000;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/redux/actions/notifications/constants.js